import { styled } from 'stitches.config'

export const HeroRoot = styled('div', {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: '$primary-800',
  width: '100%',
  px: '$12',
  paddingTop: '$10',
  '@bp2': {
    marginTop: '$10',
    paddingTop: '0',
  },
  '@bp3': {
    flexDirection: 'row',
  },
  '.cta': {
    display: 'none',

    '@bp2': {
      cursor: 'pointer',
      display: 'inline-flex',
      marginTop: '$2',
    },
  },
})

export const IllustrationContainer = styled('div', {
  position: 'relative',
  width: '328px',
  marginRight: '$5',

  '@bp3': {
    width: '500px',
  },
})

export const TextContainer = styled('div', {
  textAlign: 'center',

  '@bp3': {
    textAlign: 'left',
    maxWidth: '500px',
  },
})

export const EnergyIllustration = styled('div', {
  position: 'relative',
  top: '-$12',
  size: '$15',
  display: 'none',

  '@bp3': {
    display: 'block',
  },
})

export const Badge = styled('div', {
  size: '$15',
  marginTop: '$3',

  '@bp3': {
    position: 'relative',
    top: '$9',
    right: '$6',
    size: '144px',
    marginTop: '0px',
  },
})

export const Pattern = styled('div', {
  display: 'none',

  '@bp3': {
    display: 'block',
    position: 'absolute',
    right: 0,
    bottom: '-$10',
    width: '340px',
  },
})
